@if (content().hasTop !== false) {
    <div class="top"></div>
}
<img
    [src]="'assets/icon/' + content().img"
    class="information-template__img"
    [class.full-width]="content().fullWidth"
    [style.max-width]="content().imgMaxWidth"
/>
<div [class.no-content-padding]="content().noContentPadding">
    <div [class.centered]="content().centeredContent">
        <ng-content select="[bottom]"></ng-content>
        @if (content().title) {
            <div class="headline-bold">{{ content().title }}</div>
        }
        @if (content().text) {
            <div class="sub-headline-bold yellow">{{ content().text }}</div>
        }
    </div>
    <web-bottom-buttons [buttons]="content().buttons ?? []"></web-bottom-buttons>
</div>
